{
  "account": {
    "title": "Fiókom",
    "list": {
      "title": "Fiókok",
      "description": "Összekapcsolt fiókok számláinak listája"
    },
    "form": {
      "name": {
        "title": "Név",
        "description": "Fiókod neve"
      },
      "password": {
        "title": "Jelszó",
        "description": "Új jelszó beállítása a fiókodhoz – hagyd üresen, ha meg szeretnéd tartani a jelenlegit"
      },
      "emailPreferences": {
        "title": "E-mail beállítások",
        "description": "Válaszd ki az értesítések típusát"
      }
    },
    "billing": "Számlázási adatok",
    "subscriptions": "Előfizetések",
    "manageSubscription": "Előfizetés kezelése",
    "popup": {
      "cancel": "Biztosan lemondod az előfizetést?<br/>A webhelyed fordítása a jelenlegi időszak végéig aktív marad, utána kikapcsol.<br/>Kérjük, vedd figyelembe, hogy az időarányos visszatérítésre nem vagy jogosult.",
      "downgrade": "Biztosan visszalépsz egy alacsonyabb csomagra? A változás azonnal életbe lép.<br/>Kérjük, vedd figyelembe, hogy a hátralévő időre nem jár visszatérítés.<br/>Az új csomag díja a következő számlázási ciklusban kerül felszámításra.",
      "default": "Biztosan megváltoztatod a csomagodat?",
      "resume": "Biztosan folytatja az előfizetését?"
    }
  },
  "ai_translation": {
    "header": "AI Fordítás",
    "plan": {
      "header": "AI Fordítás árazása",
      "used": "Már felhasználtál {words_used} / {words_allowed} fordítható szót az AI-keretedből.",
      "remaining": "Rendelkezésre álló AI-keret:",
      "words": "szó",
      "add_more_credits": "További AI-keret vásárlása",
      "details": {
        "idiomatic_expressions": "Idiomatikus és műszaki kifejezések",
        "background_translation": "Fordítás a háttérben",
        "best_website": "Webhelyek, amelyek tökéletes fordítási minőséget igényelnek",
        "page_context": "Oldal- és webhely-kontextus figyelembevétele",
        "perfect_quality": "Tökéletes minőség, megfizethető áron",
        "no_recurring": "Nincs előfizetés, előre fizetett keret",
        "save_40": "40% megtakarítás a 20 $-os csomaghoz képest",
        "save_50": "50% megtakarítás a 20 $-os csomaghoz képest"
      },
      "quota": "{estimated_words} szó ≈ {estimated_pages} oldal"
    },
    "settings": {
      "banner": {
        "title": "Linguise AI Fordítás",
        "intro": "A Linguise büszkén mutatja be az új prémium AI Fordítás funkciót, amely a legfrissebb Llama nyelvi modellekre épül, kifejezetten fordítási feladatokra optimalizálva. Olyan webhelyek számára készült, amelyek hibátlan pontosságot követelnek meg: figyelembe veszi az aktuális oldal és az egész webhely kontextusát is. Kínáld ügyfeleidnek a fordítás csúcsminőségét, hogy üzenetük tökéletesen visszhangozzon minden nyelven.",
        "button": "Frissítés most"
      },
      "alert": {
        "description": "Ez a funkció nem tartozik a jelenlegi csomagodba, külön meg kell vásárolnod.\nA bővítmény aktiválásával az alábbi lehetőségek válnak elérhetővé."
      },
      "languages": {
        "title": "AI fordítás alkalmazása nyelvekre",
        "description": "Válaszd ki, melyik nyelveken szeretnéd az AI fordítást használni"
      },
      "button": {
        "save": "Beállítások mentése"
      },
      "form": {
        "advanced": {
          "title": "Haladó AI utasítások",
          "description": "Haladó AI utasítások"
        },
        "enable_mode": {
          "title": "AI FORDÍTÁS ENGEDÉLYEZÉSE",
          "description": "Válaszd ki, hogyan szeretnéd engedélyezni az AI fordítást.\n„Csak szabályok” esetén az alábbi szabályok lépnek életbe.\n„Csak élő szerkesztő” esetén oldalanként kapcsolhatod a fordítást az élő szerkesztőből.\n„Szabályok és élő szerkesztő” esetén mindkettő használható.",
          "disabled": "Kikapcsolva",
          "rules": "Csak szabályok",
          "live_editor": "Csak élő szerkesztő",
          "all": "Szabályok és élő szerkesztő"
        },
        "rule_application": {
          "description": "Alkalmazza az AI fordítást statikus, dinamikus vagy mindkét típusú tartalomra",
          "title": "Alkalmazás tartalomra",
          "all": "Minden tartalom",
          "static": "Statikus tartalom",
          "dynamic": "Dinamikus tartalom"
        },
        "website_topic": {
          "title": "Webhely témája",
          "placeholder": "Sushi étterem...",
          "description": "Határozd meg webhelyed témáját a jobb fordítási minőség érdekében (pl. jogi, sushi étterem, kerékpár-alkatrész webáruház…)\nKérjük, angolul add meg."
        },
        "apply_to_urls": {
          "title": "Alkalmazás URL-ekre",
          "description": "Válaszd ki azokat az URL-eket, ahol az AI fordítást használni szeretnéd",
          "all_urls": "Minden URL",
          "selected_urls": "Kiválasztott URL-ek",
          "label": "Alkalmazandó URL",
          "placeholder": "Alkalmazandó URL",
          "wildcard": "Helyettesítő karakter",
          "regex": "Reguláris kifejezés",
          "add": "Új hozzáadása",
          "expression": "Kifejezés típusa"
        },
        "apply_languages": {
          "title": "Alkalmazás nyelvekre",
          "description": "Válaszd ki, melyik nyelveken szeretnéd az AI fordítást használni",
          "all_languages": "Minden nyelv",
          "selected_languages": "Kiválasztott nyelvek",
          "placeholder": "Válassz nyelveket...",
          "feedback": "Ki kell választanod legalább egy nyelvet"
        },
        "formality": {
          "title": "Formalitás",
          "description": "Határozd meg a fordítás formális stílusát, ami fontos lehet bizonyos célcsoportok és kontextusok esetén.\n„Semleges” megőrzi az eredeti tartalom stílusát.\n„Formális” szakmai, üzleti vagy jogi tartalomhoz (pl. „önt” használja magyarul).\n„Informális” kötetlen, beszélt stílusú tartalomhoz (pl. „te” használata).",
          "neutral": "Semleges",
          "formal": "Formális",
          "informal": "Informális"
        },
        "sentence_structure": {
          "classic": "Klasszikus",
          "short": "Rövid, tömör mondatok",
          "detailed": "Részletes, magyarázó mondatok",
          "title": "Mondata szerkezete",
          "description": "Határozd meg az írásmód-stílust."
        },
        "content_purpose": {
          "marketing": "Marketing/promóciós (meggyőző, lekötő hangnem)",
          "technical": "Műszaki/oktató (tiszta, pontos, cselekvésorientált)",
          "support": "Ügyfélszolgálat (empatikus, segítőkész, megnyugtató)",
          "legal": "Jogi/megfelelőségi (pontos, formális, egyértelmű)",
          "educational": "Oktatási (tiszta, strukturált, hozzáférhető)",
          "other": "Egyéb (angolul)",
          "title": "Tartalom célja",
          "description": "Határozd meg a lefordítandó tartalom funkcionális célját.",
          "other_placeholder": "Írd le a célt..."
        },
        "target_audience": {
          "title": "Célközönség",
          "description": "A lefordított tartalom célközönségének meghatározása (angolul).",
          "placeholder": "pl. spanyol anyanyelvű szülők, EU adatvédelmi tisztviselők"
        },
        "override_default_translations": {
          "title": "Alapértelmezett fordítás felülírása",
          "description": "HA be van állítva IGEN-re, a rendszer a tartalmat AI-val (Linguise AI) fordítja le, még akkor is, ha azt már lefordította a Cloud AI (alapértelmezett fordítómodell)."
        },
        "force_replace_before": {
          "title": "AI-fordítás kényszerített megismétlése",
          "description": "Fordítsa le újra AI-val az összes olyan tartalmat, amelynek AI-fordítása a kiválasztott dátum előtt készült — például a régebbi modellel fordított tartalmat. Az újrafordítás a szabályok szerinti oldalak következő látogatásakor történik, és AI-krediteket használ fel.",
          "before_date": "Egy dátum előtt"
        },
        "model": {
          "current": "Aktuális",
          "title": "Modell",
          "description": "Válassza ki a használni kívánt LLM fordítási modellt",
          "load_error": "Nem sikerült betölteni az elérhető modelleket. Kérjük, próbálja újra később.",
          "thinking_warning": "Ez a modell magas szintű következtetést (\"gondolkodás\") használ, és lényegesen több tokent fog fogyasztani fordításonként."
        },
        "override_manual_and_selected": {
          "no_default": "Nem (alapértelmezett)",
          "title": "Kézi és kiválasztott fordítások felülírása",
          "description": "Alapértelmezés szerint a kézzel szerkesztett fordítás mindig megmarad a webhelyén, még az AI-val továbbfejlesztett fordítás létrehozása után is. Állítsa IGEN-re, hogy helyette az AI-val továbbfejlesztett fordítás jelenjen meg. A kézi fordítások megmaradnak, és bármikor visszaválthat. Ez arra az esetre is vonatkozik, amikor új fordítások lekéréséhez újra lefordítja az oldalakat; ilyenkor automatikusan a legújabb fordítás lesz használva."
        }
      },
      "message": {
        "save_success": "A jelenleg már lefordított tartalmakból körülbelül {{ai_affected_urls}} oldal fog AI fordítással javulni.",
        "save_success_only": "Beállítások sikeresen mentve."
      }
    },
    "pricing": {
      "plan": {
        "title": "AI fordítási keret megrendelése",
        "buy_button": "AI FORDÍTÁSI CSOMAG VÁSÁRLÁSA"
      },
      "modal": {
        "title": "Csomagváltoztatás megerősítése",
        "description": "Biztosan meg szeretnéd változtatni az AI Fordítási csomagodat?",
        "button_cancel": "Mégse",
        "button_confirm": "Megerősítés",
        "loading": "Kérjük, várjon...",
        "amount": "Összeg",
        "credit": "Egyenleg",
        "total_due": "Fizetendő összesen"
      },
      "comparison": {
        "title": "Google Cloud AI fordítás\nvs Linguise AI fordítás",
        "list": {
          "0": {
            "google": "Gyors és megbízható fordítások",
            "linguise": "Idiómák és szakmai kifejezések kezelése"
          },
          "1": {
            "google": "A webhely összes oldalának azonnali fordítása",
            "linguise": "Fordítások háttérben történő generálása"
          },
          "2": {
            "google": "Legjobb minőség, alacsony ár",
            "linguise": "Tökéletes minőség, megfizethető ár"
          },
          "3": {
            "google": "Legjobban nagy webhelyekhez vagy szűkös költségvetéshez",
            "linguise": "Legjobb azokhoz a webhelyekhez, amelyek tökéletes fordítási minőséget igényelnek"
          },
          "4": {
            "google": "Oldal-kontextus a fordításhoz",
            "linguise": "Oldal- és webhely-kontextus a fordításhoz"
          }
        }
      },
      "botom_banner": {
        "title": "Páratlan fordítási pontosság a",
        "sub_title": "Új Linguise AI fordítással",
        "description": "A Linguise frissíti automatikus fordítási szolgáltatásait a Linguise AI Fordítás bevezetésével, egy erőteljes új lehetőséggel, amely a legmodernebb, fordításokhoz optimalizált AI LLM-eket használja (a legfrissebb, fordításokra optimalizált Llama modellek). Ez a kiegészítés még magasabb fordítási minőségi szintet kínál a webfejlesztők és ügynökségek számára, ideális olyan projektekhez, ahol a tökéletesség a legfontosabb. A Linguise AI Fordítás kiegészíti meglévő, kiváló minőségű Google Cloud AI fordításunkat, nagyobb rugalmasságot és pontosságot kínálva."
      }
    },
    "success": {
      "tab_title": "Köszönjük, hogy megvásárolta az AI Fordítási csomagot!",
      "title": "Köszönjük, hogy megvásárolta az AI Fordítási csomagot!",
      "subtitle": "AI Fordítási csomagját sikeresen megvásárolta!",
      "message": "AI Fordítási csomagját az AI Fordítás beállítások oldalon kezelheti.",
      "home": "AI Fordítás kezelése"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Név",
        "description": "Számlázási fiók neve"
      },
      "phone": {
        "title": "Telefon",
        "description": "Számlázási fiók telefonszáma"
      },
      "email": {
        "title": "E-mail",
        "description": "Számlázási fiók e-mail címe"
      },
      "address": {
        "title": "Cím",
        "description": "Számlázási fiók címe",
        "city": "Város",
        "country": "Ország",
        "address1": "Cím 1",
        "address2": "Cím 2",
        "postal": "Irányítószám",
        "state": "Állam"
      },
      "tax": {
        "title": "Adószám"
      }
    }
  },
  "checkouts": {
    "header": "Pénztár",
    "payment_method": "Fizetési mód kiválasztása",
    "stripe_card": "Hitelkártya (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "Új számlázási cím megadása",
      "existing": "Meglévő cím használata"
    },
    "pay_stripe": "Megerősítés és fizetés",
    "terms": "Az előfizetés megerősítésével hozzájárul, hogy a Linguise a feltételeinknek megfelelően kiszámlázza Önnek a jövőbeli fizetéseket. Előfizetését bármikor lemondhatja.",
    "coupon": {
      "title": "Van kuponkódja?",
      "placeholder": "Írja be kuponkódját",
      "apply": "Alkalmaz",
      "percent": "{{0}}% kedvezmény"
    },
    "add_new": "Új hozzáadása",
    "use_existing": "Meglévő fizetési mód használata",
    "recurring": {
      "month_single": "Havonta számlázva",
      "month_many": "Minden {{count}} hónapban számlázva",
      "year_single": "Évente számlázva",
      "year_many": "Minden {{count}} évben számlázva",
      "day_single": "Naponta számlázva",
      "day_many": "Minden {{count}} napban számlázva",
      "week_single": "Hetente számlázva",
      "week_many": "Minden {{count}} hétben számlázva"
    },
    "add_new_no_stripe": "Új kártya hozzáadása",
    "summary": {
      "title": "Összegzés",
      "subtotal": "Részösszeg",
      "total": "Végösszeg"
    }
  },
  "dashboard": {
    "main": {
      "title": "Irányítópult"
    },
    "statistics": {
      "main_title": "Utóbbi 30 nap statisztikája",
      "characters": "Lefordított karakterek",
      "words": "Lefordított szavak",
      "bandwidth": "Bemeneti sávszélesség",
      "request": "Kérések",
      "page_views": "Oldalmegtekintések nyelvenként (utóbbi 30 nap)",
      "multilingual_views": "Többnyelvű oldalmegtekintések (utóbbi 30 nap)",
      "most_page_viewed": "20 legnézettebb oldal (utóbbi 30 nap)",
      "no_data_yet": "Még nem áll rendelkezésre adat",
      "th_language": "Nyelv",
      "th_page_views": "Oldalmegtekintések",
      "real_visitors": "Valódi látogatók",
      "crawler": "Webes feltérképező"
    },
    "planHints": {
      "subscribeButton": "Előfizetés",
      "upgradeButton": "Frissítés",
      "usedWords": "Jelenleg {words_used} szót használt",
      "noPlan": "Nincs terv aktiválva ehhez a domainhez. Iratkozzon fel egy tervre, és kezdje el lefordítani webhelyét",
      "noPlanShopify": "Nincs terv aktiválva ehhez a domainhez. Iratkozzon fel egy tervre a Shopify irányítópultjában, és kezdje el lefordítani webhelyét",
      "trialUsage": "Jelenleg a próbatervben foglalt {words_allowed} szóból {words_used} szót használt.",
      "trialEnds": "Az 1 hónapos próbaidőszak eddig tart: {trial_ends}.",
      "subscribeMessage": "Iratkozzon fel, mielőtt véget ér, hogy webhelye továbbra is le legyen fordítva",
      "subscribeMessageShopify": "Iratkozzon fel a Shopify irányítópultjából, mielőtt véget ér, hogy webhelye továbbra is le legyen fordítva",
      "trialReachedLimit": "Elérte a próbaidőszak maximális lefordított szavainak számát.\nIratkozzon fel valamelyik tervünkre, hogy folytathassa webhelye fordítását.",
      "paidUsage": "A tervben foglalt {words_allowed} lefordított szóból {words_used} szót használt.",
      "paidReachedLimit": "Elérte a jelenlegi terv maximális lefordított szavainak számát.\nFrissítse tervét, hogy folytathassa webhelytartalma fordítását.",
      "trialOfferedUsage": "Jelenleg a próbatervben foglalt {words_allowed} szóból {words_used} szót használt. (Beleértve a felajánlott {free_words} szót)",
      "paidOfferedUsage": "A tervben foglalt {words_allowed} lefordított szóból {words_used} szót használt. (Beleértve a felajánlott {free_words} szót)",
      "noPlanExtra": "Kérjük, vegye figyelembe, hogy a nem aktív domainek és adataik rendszeresen törlésre kerülnek.",
      "planRecommended": "A jelenlegi fordítási mennyisége alapján a javasolt terv:",
      "planMaximumWords": "{{words}} szó",
      "notHaveTranslatedWords": "Még nem készített fordítást"
    },
    "translationSetup": {
      "kicker": "ALDOMAIN-BEÁLLÍTÁS",
      "title": "Fordítási beállítások ellenőrzése",
      "description": "Ellenőrizze a DNS-t, a lefordított állomásokat, az eredeti webhely elérését és a fiókkorlátokat.",
      "starting": "Ellenőrzés...",
      "button": "Beállítás ellenőrzése",
      "viewLatest": "Legutóbbi eredmény megtekintése",
      "viewCurrent": "Aktuális ellenőrzés megtekintése",
      "runAgain": "Ellenőrzés újraindítása",
      "viewDetails": "Részletek megtekintése",
      "hideDetails": "Részletek elrejtése",
      "error": "A beállítás nem ellenőrizhető",
      "allPassed": "Minden ellenőrzés sikeres",
      "setupNeedsAttention": "A beállítás figyelmet igényel",
      "setupNeedsAttentionDescription": "Egy vagy több ellenőrzés nem sikerült. Tekintse át az alábbi elemeket, vagy forduljon a Linguise ügyfélszolgálatához.",
      "lastChecked": "Utolsó ellenőrzés: {{time}}",
      "domainOwnership": "Domain tulajdonjoga",
      "domainOwnershipDescription": "Ellenőrzési rekord található",
      "domainOwnershipFailure": "A tulajdonjogot igazoló DNS-rekord nem ellenőrizhető.",
      "translatedHosts": "Lefordított állomások",
      "translatedHostsDescription": "{{count}} nyelvi állomás ellenőrizve",
      "translatedHostsFailure": "Egy vagy több nyelvi CNAME-rekord helytelen.",
      "subdomainPage": "Aldomainoldal",
      "subdomainPageDescription": "{{count}} lefordított oldal fogad HTTPS-kapcsolatot",
      "subdomainPageFailure": "A TLS-kapcsolat meghiúsult egy vagy több lefordított oldal megnyitásakor.",
      "originalSite": "Eredeti webhely",
      "originalSiteDescription": "Az eredeti webhely DNS-, TLS- és válaszellenőrzései",
      "originalSiteFailure": "Az eredeti webhely DNS-, TLS- vagy válaszellenőrzése nem sikerült.",
      "documentationAdvice": {
        "dns": "DNS-beállítás áttekintése",
        "tls": "HTTPS-beállítás áttekintése",
        "origin": "Az eredeti webhely beállításának áttekintése",
        "diagnostic": "Hibaelhárítási lépések áttekintése"
      },
      "evidence": {
        "originDns": "Eredeti DNS",
        "originTls": "Eredeti TLS",
        "originHttp": "Eredeti válasz",
        "observedTargets": "Észlelt célok",
        "recordCount": "Talált rekordok",
        "addressCount": "Talált címek",
        "statusCode": "HTTP-állapot",
        "redirect": "Átirányítás",
        "expiresAt": "A tanúsítvány lejár",
        "raw": "{{key}}",
        "noValue": "Nincs érték"
      },
      "checkerError": "Néhány ellenőrzést nem sikerült befejezni.",
      "coreLocation": "Ellenőrzés innen: {{location}}",
      "status": {
        "queued": "Várólistán",
        "running": "Folyamatban",
        "completed": "Befejezve",
        "failed": "Sikertelen",
        "passed": "Sikeres",
        "warning": "Figyelmeztetés",
        "unknown": "Ismeretlen",
        "skipped": "Kihagyva",
        "not_applicable": "Nem alkalmazható"
      }
    },
    "throttling": {
      "title": "Fordítási korlát",
      "description": "Ideiglenes használati korlátok",
      "unavailable": "Az ideiglenes fordítási korlátok nem érhetők el",
      "window": "{{used}} / {{max}} szó",
      "resetsIn": "Visszaállítás: {{time}} múlva",
      "throttled": "A fordítás ideiglenesen szünetel",
      "throttledDescription": "Elérte az ideiglenes használati korlátot. A fordítás az időszak visszaállításakor folytatódik."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "{{step}}. LÉPES ÖSSZESEN {{total}}",
      "doneLabel": "KÉSZ, KEZDŐDHET A FORDÍTÁS!",
      "finish": {
        "title": "",
        "description": "Ez az API-kulcs, amelyet webhelyén kell használnia"
      },
      "instructions": "Telepítési utasítás",
      "domainSetting": "Domain beállítás",
      "step": {
        "titleWordpress": "WordPress",
        "titleJoomla": "Joomla",
        "titlePHP": "PHP szkript",
        "wizardWordpressStep1": "1. Telepítse a ",
        "wizardWordpressStep2": "\n 2. A bővítmény beállításaiban másolja ki és töltse ki API-kulcsát\n",
        "wizardWordpressStep3": "3. Készen áll a fordításra\n\n",
        "wizardWordpressStep4": "Részletesebb útmutatásért tekintse meg dokumentációnkat: ",
        "wizardJoomlaStep1": "1. Joomla csomag hivatkozása: ",
        "wizardJoomlaStep2": "\n2. A bővítmény konfigurációs beállításaiban másolja ki és töltse ki az API-kulcsát",
        "wizardJoomlaStep3": "3. A modul konfigurációjában állítsa be a megjeleníteni kívánt nyelveket, és helyezze el a modult ahol szükséges.",
        "wizardJoomlaStep4": "\n4. Készen áll a fordításra\n\n",
        "wizardPhpStep1": "1. Töltse le php-szkriptünket és itt ",
        "wizardPhpStep2": "\n2. Kövesse a dokumentációs oldalunkon található telepítési útmutatót itt ",
        "wizardPhpStep3": "\n3. Adja hozzá a modult az oldalaihoz.",
        "wizardPhpStep4": "\nMásolja ki az alábbi kódot, és helyezze el a HTML-oldal head-részébe; automatikusan megjeleníti a váltómodult\n",
        "dispatchStep1": "A szükséges adatokat sikeresen elküldtük a Linguise bővítménynek, most bezárhatja az alábbi ablakot.",
        "dispatchStep2": "Abban az esetben, ha a token hiányzik amikor bezárja ezt az ablakot, kérjük másolja ki az alábbi tokent:",
        "dispatchStep3": "Ezt a kódrészletet is másolhatja, hogy automatikusan engedélyezze a zászlóváltónkat",
        "wizardOtherStep1": "Kövesse az alábbi utasításokat a Linguise telepítéséhez a domainjére.\n",
        "wizardOtherStep2": "Másolja ki az alábbi kódot, és helyezze el a HTML-oldal head-részébe; automatikusan megjeleníti a váltómodult.\n"
      },
      "trialAlreadyUsed": "Úgy tűnik már felhasználta az ingyenes próbáját, így fordítási kvótára van szüksége\nKérjük fizessen elő egy csomagra vagy lépjen kapcsolatba velünk, ha szeretné meghosszabbítani próbáját.",
      "usefulLinks": "Hasznos linkek az induláshoz",
      "linkDocumentation": "Dokumentáció",
      "linkExtensionDl": "Bővítmény letöltése",
      "linkSubscribe": "Iratkozzon fel egy csomagra most",
      "linkDashboard": "Ugrás az irányítópultra",
      "exclusion": {
        "title": "Cégek és termékek neve",
        "description": ""
      },
      "finishButton": "A beállítás befejezése",
      "subdomains": "Subdomainek",
      "subdomain_setup": "Domain beállítása",
      "subdomain_auto_setup": "DNS-jének automatikus csatlakoztatása",
      "subdomain_manual_setup": "DNS-bejegyzések hozzáadása manuálisan",
      "subdomain_skip": "Később megcsinálom",
      "auto_subdomains_info": "Az Ön webhelykészítő CMS-e DNS-konfigurációt igényel, hogy nyelvenként subdomainet állítson be (pl. hu.domain.com).",
      "auto_subdomains_info_2": "Ezt automatikusan megteheti az Entrivel. Egyszerűen kattintson a „Csatlakoztassa DNS-jét automatikusan” gombra, hogy elindítsa a csatlakozást a DNS-kezelőjéhez és hozzáadja azokat az Entrivel.",
      "auto_subdomains_info_manual": "Vagy kézzel is konfigurálhatja domainjét a „DNS-bejegyzések hozzáadása manuálisan” gombra kattintva.",
      "breadcrumbs": {
        "step1": "1. lépés: Domain, CMS és nyelvek",
        "step2": "2. lépés: Nyelvi DNS",
        "step3": "{{step}}. lépés: Telepítési utasítások"
      }
    },
    "form": {
      "urls": {
        "dash": "Kötőjel -",
        "underscore": "Aláhúzás _",
        "title": "URL-ek fordítása",
        "description": "Szeretné lefordítani minden oldalon",
        "char_description": "A nem engedélyezett karakterek URL-beli helyettesítésére használt karakter",
        "advertisement_title": "⚠ Sok nyelvet állított be.\n",
        "advertisement": "Általában azt javasoljuk, kezdetben kevés nyelvre fordítsa le webhelyét. Így képet kaphat róla, mennyi szó található az oldalain. Ez SEO-szempontból is jobb, mivel a Google-botok gyorsabban feltérképezik az oldalakat, ha kevesebb oldallal indul. Egy hét múlva hozzáadhat még néhány nyelvet, és így tovább."
      },
      "url": {
        "title": "Url",
        "description": "Adja meg fő domainjének URL-jét http:// vagy https:// kezdetű formában",
        "placeholder": "Domain URL-címe",
        "advertisement_http": {
          "title": "Nem használ https protokollt",
          "description": "Kérjük ellenőrizze, hogy domainje valóban nem használ https protokollt, ami manapság ajánlott."
        },
        "advertisement_www": {
          "title": "Az Ön subdomainje nem www",
          "description": "A legtöbb esetben az alapértelmezett subdomain a www (pl. https://www.mydomain.com). Lehet, hogy ez nem így van, de kérjük kétszer is ellenőrizze, hogy a hozzáadni kívánt domain megfelelő-e."
        },
        "invalid_url": {
          "line1": "Nem találtuk meg domainjét. Kérjük ellenőrizze, hogy domainje nyilvánosan elérhető-e az Interneten, és nincs-e átirányítva más helyre.",
          "line2": "Ha biztos benne, hogy domainje elérhető, átugorhat a domain ellenőrzését és ismét megnyomhatja a „Következő lépés” gombot",
          "contact": "Bármilyen esetben elérhet bennünket itt:",
          "force": "Domain ellenőrzés kihagyása"
        },
        "invalid_subdomain_url": "Ez az URL nem engedélyezett. Az aldomaineknek https://www.domain.tld vagy https://domain.tld formátumban kell lenniük alkönyvtár nélkül."
      },
      "account": {
        "title": "Fiók",
        "description": "Válasszon fiókot a domain hozzárendeléséhez",
        "placeholder": "Fiók kiválasztása...",
        "feedback": "Kötelező fiókot választania"
      },
      "platform": {
        "title": "Platform",
        "description": "Kérjük válassza ki webhelye platformját a CMS neve alapján.",
        "learn": "Tudjon meg többet a választásról",
        "placeholder": "Keressen platformra CMS-név alapján...",
        "info": {
          "title": "⚠ Ezt a platformot nemrég adták hozzá.\n",
          "desc": "Ezt a webhelykészítő platformot a Linguise támogatja, bár nemrég adták hozzá. Ha bármilyen problémát tapasztal, kérjük lépjen kapcsolatba velünk közvetlen támogatási e-mail-címen:"
        },
        "description_read_only": "Az Ön webhelye által használt platform",
        "feedback": "Kötelező platformot választania"
      },
      "language": {
        "title": "Nyelv",
        "description": "Válassza ki webhelye alapnyelvét",
        "placeholder": "Nyelv kiválasztása...",
        "feedback": "Kötelező nyelvet választania",
        "description_read_only": "Webhelye alapnyelve"
      },
      "token": {
        "title": "API-kulcs",
        "description": "Ezt az API-kulcsot kell kimásolnia webhelyére",
        "copy": "Másolás vágólapra",
        "reset": "API-kulcs visszaállítása",
        "reset_confirm": "Kérjük erősítse meg az API-kulcs visszaállítását"
      },
      "languages": {
        "title": "Fordítási nyelvek",
        "description": "Válassza ki azokat a nyelveket, amelyekre szeretné, hogy webhelye lefordítható legyen",
        "placeholder": "Nyelvek kiválasztása...",
        "feedback": "Kötelező nyelvet választania"
      },
      "defaultRules": {
        "title": "Alapértelmezett szabályok",
        "description": "Meghatároztunk egy szükséges szabálykészletet a fordítás javítása és a nem kívánt tartalmak, például a WordPress adminfelület fordításának elkerülése érdekében.\nKésőbb eltávolíthatja vagy szerkesztheti ezeket a szabályokat, ha szeretné."
      },
      "disallow_deletion": "Nem törölhető domain aktív előfizetéssel",
      "delete_confirm": "Kérjük erősítse meg a domain törlését",
      "delete": "Domain törlése",
      "dynamic": {
        "title": "Dinamikus tartalom fordítása",
        "description": "A JavaScript és AJAX-kérések által generált dinamikus tartalom is lefordításra kerül (Ez az opció növelni fogja fordítási forgalmát)"
      },
      "partial_translations": {
        "title": "Részleges fordítás engedélyezése",
        "description": "Ha fiókja elérte fordítási kvótáját, de az oldalnak még szüksége van fordításra, a Linguise folytathatja az oldal megjelenítését a már lefordított tartalommal.\nAz oldal egyes részei azonban fordítatlanok maradnak, amíg nem növeli kvótáját.\n\nMíg egy kis mennyiségű lefordítatlan tartalom nem szokta károsítani a SEO-t, túl sok lefordítatlan tartalom kedvezőtlenül hathat a felhasználói élményre.\nEnnek kezelésére beállíthat egy küszöbértéket a megengedett lefordítatlan tartalom százalékáról az oldalon. Ha a lefordítatlan tartalom meghaladja ezt a küszöbértéket, a felhasználók automatikusan az eredeti nyelvű verzióra lesznek átirányítva.",
        "never": "Soha"
      },
      "translate_error_pages": {
        "title": "Hibaoldalak fordítása",
        "description": "A Linguise le tud fordítani minden hibaoldalt, ám ha hibaoldala dinamikus tartalmat tartalmaz, például IP-címet vagy kérési azonosítót, érdemes kerülni ezen oldalak fordítását.",
        "not_found_page": {
          "title": "404-es oldal fordítása"
        },
        "error_page": {
          "title": "Egyéb hibaoldalak fordítása"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Meglévő domain található",
          "description": "Meglévő domain található ennél a felhasználónál, szeretné használni?"
        }
      },
      "search_tl": {
        "title": "Fordítások keresése",
        "description": "Keresési fordítások engedélyezése webhelye platformjához (Kísérleti, ez az opció növelni fogja fordítási forgalmát)"
      },
      "shopify_promo": {
        "info": "Jó hír! Most már van egy Shopify natív alkalmazásunk, amelyet telepíthetsz a Shopify App Store-ból",
        "hyperlink": "Kattints ide, és telepítsd a Linguise-t az alkalmazásból.",
        "next_btn": "Az alkalmazás telepítéséhez látogasson el a Shopify áruházba",
        "info_legacy": "Jó hír! Most már van egy Shopify natív alkalmazásunk, amelyet telepíthetsz a Shopify App Store-ból",
        "description_legacy": "Válaszd a „Shopify” platformot a „Shopify Legacy” helyett"
      },
      "wix_promo": {
        "info": "Jó hír! Most már van egy Wix natív alkalmazásunk, amelyet telepíthetsz a Wix App Marketből.",
        "hyperlink": "Kattints ide, és telepítsd a Linguise-t az alkalmazásból.",
        "next_btn": "Az alkalmazás telepítéséhez látogasson el a Wix App Marketbe",
        "info_legacy": "Jó hír! Most már van egy Wix natív alkalmazásunk, amelyet telepíthetsz a Wix App Marketből.",
        "description_legacy": "Válaszd a „Wix” platformot a „Wix Legacy” helyett"
      },
      "ai_disallow_deletion": "Nem törölheti ezt a domaint, amíg még rendelkezésre áll egy mesterséges intelligencia-kvóta.\n\nKérjük, lépjen kapcsolatba ügyfélszolgálatunkkal, ha törölni szeretné ezt a domaint a címen",
      "language_removal": {
        "card": {
          "title": "Eltávolított nyelvek fordításainak törlése",
          "description": "Ezeket a nyelveket eltávolították a webhelyéről, de a mentett fordításaik továbbra is beleszámítanak a keretbe. Törölje őket, hogy visszakapja a szavakat.",
          "button": "Fordítások törlése"
        },
        "hint": "A felhasznált szavak visszakerülnek a keretébe. Ezt webhelyenként {{days}} naponta egyszer teheti meg.",
        "modal": {
          "title": "Törli a fordításokat?",
          "intro": "Ezek a fordítások véglegesen törlődnek:",
          "warning": "Ez a művelet nem vonható vissza. A felhasznált szavak visszakerülnek a keretébe, ami néhány percet vehet igénybe.",
          "limit": "Ezt webhelyenként {{days}} naponta egyszer teheti meg.",
          "confirm": "Fordítások törlése"
        },
        "scheduled": "A fordítások törlése folyamatban van, a keret hamarosan frissül.",
        "cooldown": "A webhely fordításait nemrég törölték. Újra {{date}} dátumtól törölheti őket.",
        "latest_completed": {
          "title": "Legutóbbi befejezett törlés",
          "description": "Tekintse át a törölt nyelveket és a keretébe visszakerült szavakat.",
          "languages": "Törölt nyelvek",
          "words_returned": "A keretébe visszakerült szavak: {{words}}",
          "completed_at": "Befejezve: {{date}}"
        },
        "status": {
          "recent_title": "Legutóbbi fordítástörlés",
          "recent_description": "Kövesse a legutóbbi törlést, és nézze meg, mikor indítható a következő.",
          "progress_title": "Törlési folyamat",
          "loading": "Törlési folyamat ellenőrzése...",
          "unavailable": "Nem sikerült betölteni a törlési folyamatot. Frissítse az oldalt, majd próbálja újra.",
          "label": "Állapot",
          "pending": "Várólistán",
          "processing": "Folyamatban",
          "completed": "Befejezve",
          "failed": "Sikertelen",
          "unknown": "Az állapot nem érhető el",
          "percent": "{{percent}}% kész",
          "current_stage": "Jelenlegi lépés: {{stage}}",
          "processed": "{{processed}} rekord feldolgozva",
          "processed_total": "{{total}} rekordból {{processed}} feldolgozva",
          "requested_at": "Kérve: {{date}}",
          "started_at": "Elindítva: {{date}}",
          "completed_at": "Befejezve: {{date}}",
          "cooldown_period": "Ezt webhelyenként {{days}} naponta egyszer teheti meg.",
          "cooldown_blocked": "Még nem indítható újabb törlés.",
          "stage": {
            "queued": "Indításra vár",
            "processing": "Folyamatban",
            "refund_summary": "Visszaadott szavak számítása",
            "search_translations": "Keresési fordítások törlése",
            "url_translations": "URL-fordítások törlése",
            "translations": "Fordítások törlése",
            "completed": "Befejezve",
            "failed": "Sikertelen",
            "unknown": "Folyamatban"
          }
        },
        "forbidden": "Nincs engedélye fordítások törléséhez."
      }
    },
    "main": {
      "edit": "Domain szerkesztése",
      "add": "Domain hozzáadása",
      "wizard": "Üdvözöljük! Új domain létrehozása varázsló",
      "common": "Domain"
    },
    "notice": {
      "broken_card": "Nem tudtuk megújítani csomagját a(z) {{url}} címen a jelenlegi fizetési módszerrel, kérjük frissítse fizetési kártyáját",
      "quota_reached": "Elérte fordítási kvótáját a(z) {{url}} címen, kérjük frissítsen a webhelyfordítás folytatásához",
      "ai_no_subscription": "Az AI-fordítás a(z) {{url}} címen aktív előfizetést vagy aktív próbát igényel. Enélkül leáll, kérjük frissítsen a folytatáshoz",
      "important": "Fontos",
      "quota_reached_button": "Frissítse most a csomagját",
      "broken_card_button": "Frissítse fizetési kártyáját",
      "ai_no_subscription_button": "Frissítse most a csomagját",
      "quota_warning": "A {{url}} webhely fordítási kvótája elérte a {{throttling_used_percent}}%-ot, ez {{ttl}} múlva visszaáll alaphelyzetbe",
      "locked": "A(z) {{url}} domain jelenleg migráció miatt zárolva van, továbbra is hozzáférhet webhelyéhez, de nem tud szerkeszteni vagy új fordításokat hozzáadni!"
    },
    "subdomains": {
      "config_ok": "Az aldomain DNS-e megfelelően be lett állítva.",
      "config_invalid": "Az aldomain DNS-éhez további beállítások szükségesek.",
      "config_check": "Az aldomain DNS-beállítás ellenőrzése folyamatban, kérem várjon...",
      "entri_timeout": "Az Entri jelentette, hogy az aldomain DNS propagálási folyott lejárt; újra kell próbálnia, vagy manuálisan is elvégezheti.",
      "entri_process": "A DNS-t hozzáadtuk az Entrivel, a propagálás általában 10-30 percet vesz igénybe (minden nyelvi aldomain hozzáadása, például hu.domain.com). Ha 24 óra múlva sem fejeződik be az ellenőrzés, forduljon a támogatáshoz: support@linguise.com",
      "entri_ok": "A DNS propagálás folyamatban! Várunk a propagálásra...",
      "infos": "A fordítás aktiválásához hozzá kell adnia ezeket a DNS-bejegyzéseket a DNS-tartományrekordjaihoz. Kattintson a pipa gombra, ha elkészült. Lehetséges, hogy a DNS-rekordok terjedése eltarthat egy ideig, ezért előfordulhat, hogy néhány perc vagy óra múlva vissza kell térnie.",
      "check": "DNS-konfiguráció ellenőrzése"
    },
    "subscription": {
      "next_payment_amount": "Közelgő terhelések",
      "next_payment_date": "Következő fizetési dátum",
      "invoice": {
        "header": "Számlatörténet",
        "date": "Dátum",
        "amount_due": "Összeg",
        "status": "Állapot",
        "actions": "Műveletek",
        "description": "Amint rendelkezésre állnak tranzakciók, itt tekintheti meg őket.",
        "status_text": {
          "draft": "Piszkozat",
          "failed": "Sikertelen",
          "open": "Függőben",
          "paid": "Fizetve",
          "retrying": "Újrapróbálás",
          "uncollectible": "Behajthatatlan",
          "void": "Érvénytelenített"
        },
        "view": "Megtekint",
        "empty": "Nincs friss számla ehhez az előfizetéshez",
        "retry_payment": "Újra"
      },
      "next_cancellation": "Lemondás dátuma",
      "cancel": "Előfizetés lemondása",
      "change_plan": "Csomagváltás",
      "change": "Módosít",
      "suspend": "Fizetés felfüggesztése",
      "resume": "Előfizetés folytatása",
      "back": "Vissza",
      "save": "Mentés",
      "confirm_resume": "Biztosan folytatja ezt az előfizetést?",
      "confirm_cancel": "Biztosan lemondja ezt az előfizetést?",
      "confirm_header": "Biztos benne?",
      "missing_status": "Ez az előfizetés nem található",
      "not_found": "Nem található előfizetés ehhez a domainhez",
      "confirm_manual_retry": "Biztosan újrapróbálja ezt a kifizetést?",
      "no_payment_method": "Ismeretlen",
      "remove_billing": "Eltávolít",
      "shopify_maneged": "Ez az előfizetést a Shopify kezeli. Kérjük, a Shopify admin felületén intézze.",
      "unknown_plan": "Ismeretlen csomag"
    }
  },
  "domain_listing": {
    "add": "Webhely hozzáadása",
    "select": "Válasszon domaint"
  },
  "editable": {
    "number": "szám {{id}}"
  },
  "footer": {
    "about": "Rólunk",
    "support": "Támogatás"
  },
  "frontendEditor": {
    "main": "Élő szerkesztő",
    "description": "Az Élő szerkesztővel közvetlenül a weboldalán szerkesztheti a fordításokat.",
    "button": "Élő szerkesztő megnyitása",
    "language_selection": "Fordítási nyelv kiválasztása",
    "video_label": "Tanulja meg, hogyan használja az élő szerkesztőt"
  },
  "general": {
    "403": {
      "tab_title": "Hoppá – 403 hiba",
      "title": "Hozzáférés megtagadva",
      "message": "Úgy tűnik, nincs jogosultsága a kért oldalhoz.",
      "home": "Vissza a főoldalra"
    },
    "404": {
      "tab_title": "Hoppá – 404 hiba",
      "title": "Az oldal nem található",
      "message": "Úgy tűnik, eltévedt. Ne aggódjon... a legjobbakkal is előfordul. Itt egy kis tipp, hogy visszataláljon.",
      "home": "Vissza a főoldalra"
    },
    "500": {
      "tab_title": "500 hiba",
      "title": "Belső kiszolgálóhiba",
      "message": "Miért nem frissíti az oldalt? Vagy írhat nekünk.",
      "home": "Vissza a főoldalra"
    },
    "fields": {
      "alert": "Néhány mező érvénytelen; javítsa ki azokat.",
      "invalid": "Ez a mező érvénytelen",
      "phone_re": "Telefonszám érvénytelen",
      "phone_invalid": "Telefonszám érvénytelen",
      "email": "Az e-mail mező érvénytelen"
    },
    "table": {
      "no_data": "Még nincs adat..."
    },
    "saving": "Mentés...",
    "save": "Mentés",
    "save_and_quit": "Mentés és kilépés",
    "invite": "Meghívás",
    "cancel": "Mégse",
    "yes": "Igen",
    "no": "Nem",
    "nextStep": "Következő lépés",
    "loading": "Kérem várjon, amíg az alkalmazás betölt",
    "goback": "Vissza",
    "manage": "Kezelés",
    "delete": "Törlés",
    "deleting": "Törlés...",
    "confirm": "Megerősít",
    "unknown": "Ismeretlen",
    "hide": "Elrejt",
    "show": "Megmutat",
    "on": "Be",
    "off": "Le",
    "default": "Alapértelmezett"
  },
  "home": {
    "header": "Főoldal",
    "manage": "Előfizetés kezelése",
    "canceled": "Lemondás ütemezve",
    "activate_now": "Aktiválás most",
    "activate_plan_now": "Előfizetés most",
    "upgrade_plan_now": "Csomag frissítése most",
    "trial_message_part_1": "Jelenleg próbaidőszakon van,",
    "trial_message_part_2": "bármikor aktiválhat tagságot.",
    "add": "Domain hozzáadása",
    "table": {
      "title": "Domainek",
      "description": "Domainjeinek listája; kattintson egy domainre a fordítások kezeléséhez"
    },
    "domains": {
      "empty": "Nincsenek domainek ebben a fiókban"
    },
    "accountsList": {
      "title": "Fiókok",
      "add": "Új fiók hozzáadása",
      "name": "Fiók neve"
    },
    "update_credit_card": "Bankkártyaadatok frissítése",
    "cancelling_subs": "Lemondás {{0}} időpontban",
    "resume_subscription": "Előfizetés folytatása",
    "shopify_managed": "Shopify által kezelt",
    "trial_ends_at": "Vége: {{0}}",
    "free_trial": "Ingyenes próbaverzió",
    "no_subs": "Nincs aktív előfizetés"
  },
  "invoices": {
    "title": "Számlák",
    "list": {
      "title": "Számlák listája"
    },
    "table": {
      "customer": "Vevő",
      "domain": "Domain",
      "amountPaid": "Fizetett összeg",
      "status": "Állapot",
      "date": "Dátum",
      "invoice": "Számla",
      "pay": "Számla kifizetése",
      "actions": "Műveletek",
      "deleted_domain": "Törölt domain",
      "plan_name": "Csomag",
      "action": "Művelet"
    },
    "listPending": {
      "title": "Függőben lévő számlák listája"
    }
  },
  "language_settings": {
    "display": "Nyelvi lista megjelenítése",
    "position": "Pozíció",
    "display_help_text": "Zászló és/vagy nyelvnevek megjelenítése. A nyelvváltó alapértelmezett pozíciója bárhol lehet a tartalomban, vagy rögzített helyen maradhat, illetve görgetéskor is mozoghat",
    "side_by_side": "Egymás mellett",
    "dropdown": "Legördülő",
    "popup": "Felugró",
    "flag": "Zászló",
    "lang_name": "Nyelv neve",
    "lang_short_name": "Rövid nevek",
    "positions": {
      "in_place": "Helyben",
      "top_left": "Bal felső",
      "top_left_no_scroll": "Bal felső (nincs görgetés)",
      "top_right": "Jobb felső",
      "top_right_no_scroll": "Jobb felső (nincs görgetés)",
      "bottom_left": "Bal alsó",
      "bottom_left_no_scroll": "Bal alsó (nincs görgetés)",
      "bottom_right": "Jobb alsó",
      "bottom_right_no_scroll": "Jobb alsó (nincs görgetés)"
    },
    "lang_names_display": {
      "title": "Nyelvnevek megjelenítése",
      "help_text": "A nyelvváltóban a nyelvnevek angolul vagy az eredeti nyelven jelenjenek meg, pl. French vagy Français",
      "english": "Angol",
      "native_languages": "Eredeti nyelvek"
    },
    "flag_shape": {
      "title": "Zászlóstílus",
      "help_text": "Kerek vagy téglalap alakú svg zászlóikonok használata",
      "round": "Kerek",
      "rectangular": "Téglalap"
    },
    "english_flag_type": {
      "title": "Angol zászló típusa",
      "help_text": "Nagy-Britannia vagy USA zászló használata az angol nyelvhez",
      "usa": "USA zászló",
      "great_britain": "Nagy-Britannia zászló"
    },
    "german_flag_type": {
      "title": "Német zászló típusa",
      "help_text": "Ausztria vagy Németország zászló használata a német nyelvhez",
      "german": "Német zászló",
      "austria": "Ausztria zászló"
    },
    "spain_flag_type": {
      "title": "Spanyol zászló típusa",
      "help_text": "Mexikó vagy Spanyolország zászló használata a spanyol nyelvhez",
      "spanish": "Spanyol zászló",
      "mexico": "Mexikói zászló",
      "peruvian": "Perui zászló"
    },
    "portugal_flag_type": {
      "title": "Portugál zászló típusa",
      "help_text": "Portugália vagy Brazília zászló használata a portugál nyelvhez",
      "portugal": "Portugál zászló",
      "brazil": "Brazília zászló"
    },
    "taiwanese_flag_type": {
      "title": "Tajvani zászló típusa",
      "help_text": "Tajvan vagy Kína zászló használata a tajvani nyelvhez",
      "taiwanese": "Tajvani zászló",
      "chinese": "Kínai zászló"
    },
    "flag_border_radius": {
      "title": "Zászló sarokgörbület (px)",
      "help_text": "Ha téglalap alakú zászlót használ, egyedi sarokgörbületet állíthat be képpontokban"
    },
    "flag_width": {
      "title": "Zászló mérete (px)",
      "help_text": "Válassza ki a zászlók méretét képpontokban. Ez nem változtatja meg a kép súlyát, mivel .svg formátumú"
    },
    "lang_color": {
      "color_title": "Nyelvnév színe",
      "color_help_text": "Válasszon alapértelmezett szövegszínt a nyelvnevekhez",
      "hover_color_title": "Nyelvnév szöveg színe rámutatáskor",
      "hover_color_help_text": "Válasszon rámutatáskor megjelenő szövegszínt a nyelvnevekhez",
      "color_popup_title": "Felugró nyelv színe",
      "color_popup_help_text": "A felugró vagy legördülő területeken a nyelvcím színe",
      "hover_color_popup_title": "Felugró nyelv rámutatáskori színe",
      "hover_color_popup_help_text": "Válasszon rámutatáskor megjelenő szövegszínt a felugró vagy legördülő területeken a nyelvcímhez"
    },
    "flag_box_shadow": {
      "shadow_title": "Zászló árnyéka",
      "shadow_help_text": "Szín és árnyékméret a nyelvi zászlókhoz",
      "hover_shadow_title": "Zászló árnyéka rámutatáskor",
      "hover_shadow_help_text": "Szín és árnyékméret a nyelvi zászlókhoz rámutatáskor",
      "shadow_h_offset": "Árnyék V eltolás (px)",
      "shadow_v_offset": "Árnyék F eltolás (px)",
      "shadow_blur": "Árnyék elmosás (px)",
      "shadow_spread": "Árnyék terjedés (px)",
      "shadow_color": "Árnyék színe"
    },
    "order": "Nyelvek sorrendje",
    "language_order_help": "A nyelvváltóban megjelenő nyelvek sorrendje. Húzással átrendezheti őket.",
    "order_reset": "Sorrend visszaállítása",
    "language_order_dragdrop": "Húzással átrendezheti a nyelveket.",
    "popup_lang_name": "Felugró nyelv neve",
    "preview": "Nyelvi előnézet"
  },
  "link": {
    "form": {
      "original": {
        "title": "Eredeti forrás",
        "description": "Adja meg az eredeti link URL-jét, és cserélje le alább nyelvenként a fordításhoz",
        "srcset_description": "Kép URL-jét szerkeszti. Kérjük, olvassa el a dokumentációt, különösen, ha srcset-et használ, vagy nem tudja, mi az",
        "link": "Hivatkozás",
        "match_link": "Egyeztetési mód",
        "match_exact": "Pontos",
        "match_wildcard": "Helyettesítő",
        "match_regex": "Reguláris kifejezés"
      },
      "alternative_languages": {
        "title": "Csere link",
        "description": "Csere média- és külső linkek az oldalaidon, nyelvenként…",
        "link": "Csere link"
      },
      "error": {
        "atLeastOne": "Legalább egy fordítást adj meg.",
        "url": "Érvénytelen az URL",
        "extension": "A linknek legyen kiterjesztése, de nem lehet .html vagy .php. A link sem tartalmazhat nyelvi útvonalat, pl. \"/fr\"",
        "regex": "Érvénytelen a regex",
        "wildcard": "A joker link protokollja érvénytelen"
      }
    },
    "main": {
      "parent": "Linkek",
      "edit": "Link szerkesztése"
    }
  },
  "links": {
    "title": "Média- és külső linkek kezelése",
    "description": "Listázd és szerkeszd a weboldalad média- és külső linkjeit.",
    "add": "Link hozzáadása",
    "delete": "Link törlése",
    "table": {
      "original": "Eredeti",
      "language": "Nyelv",
      "translation": "Fordítás",
      "action": "Művelet",
      "delete_confirm": "Erősítsd meg a link törlését"
    }
  },
  "members": {
    "header": "Tagok",
    "invite": "Új tag meghívása",
    "modal": {
      "inviteHeader": "Új tag meghívása",
      "editHeader": "Tag szerkesztése",
      "detachHeader": "Tag leválasztása",
      "detachBody": "Biztosan le akarod választani a tagot erről a fiókról?",
      "selfDetachBody": "Biztosan le akarod választani magad ennek a fióknak a kezeléséről? Utána nem fogsz hozzáférni a fiókhoz tartozó adatokhoz."
    },
    "table": {
      "title": "Taglista",
      "description": "Tag szerepkörök és domain-hozzáférések",
      "name": "Név",
      "email": "E-mail",
      "websites": "Weboldalak",
      "languages": "Nyelvek",
      "role": "Szerepkör",
      "status": "Állapot",
      "resendInvite": "újraküldés",
      "inviteSent": "meghívó elküldve",
      "actions": "Műveletek",
      "edit": "Szerkesztés",
      "detach": "Leválasztás",
      "empty": "Még nincsenek tagjaid",
      "all_website": "Minden weboldal és nyelv",
      "roles": {
        "admin": "Admin",
        "manager": "Menedzser",
        "translator": "Fordító"
      },
      "statuses": {
        "pending": "Függőben",
        "accepted": "Elfogadva",
        "declined": "Elutasítva"
      }
    },
    "errors": {
      "role": "Ki kell választani egy szerepkört",
      "domains": "A kiválasztott szerepkörhöz legalább 1 weboldalt meg kell adni",
      "languages": "A kiválasztott weboldalakhoz legalább 1 nyelvet meg kell adni"
    },
    "inviteSent": "A meghívót sikeresen elküldtük"
  },
  "pagination": {
    "showing": "{{limit}} / {{total}} találat megjelenítve",
    "showing_only_count": "{{limit}} találat megjelenítve"
  },
  "payments_method": {
    "header": "Fizetési módok",
    "table": {
      "title": "Fizetési módok listája",
      "description": "A fiókodhoz kapcsolt fizetési módok",
      "default": "Alapértelmezett",
      "action_edit_remove": "Szerkesztés vagy törlés",
      "action_remove": "Eltávolítás",
      "action_default": "Alapértelmezettként beállít",
      "action_fallback": "Vésztartaléknak beállít",
      "expires": "Lejárat",
      "add_new_card": "Fizetési mód hozzáadása",
      "action_fallback_remove": "Eltávolítás vésztartalékból",
      "fallback": "Vésztartalék",
      "action_edit": "Szerkesztés",
      "action_delete": "Törlés",
      "action_default_remove": "Alapértelmezett törlése",
      "domain_count@@one": "{{count}} domain használja",
      "domain_count@@other": "{{count}} domain használja"
    },
    "paypal_bind": {
      "button": "PayPal-fiók csatlakoztatása",
      "button_load": "Csatlakozás…",
      "disconnected": "Nincs csatlakoztatva",
      "success": "A PayPal-fiókod csatlakoztatva van, 5 USD levonásra kerül a következő számládról!",
      "success_no_promo": "A PayPal-fiókod csatlakoztatva van",
      "error": "Hiba történt",
      "success_header": "Siker"
    },
    "card_add": {
      "header": "Új kártya",
      "success": "Az új kártya csatlakoztatva a Linguise-hez!",
      "terms": "A kártyaadatok megadásával hozzájárulsz, hogy a Linguise a jövőben a szolgáltatási feltételeknek megfelelően terhelje a kártyádat."
    },
    "card_detail": {
      "header": "Kártya infó",
      "delete": {
        "error": "Nem törölheted ezt a fizetési módot, mert van aktív előfizetésed!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Előfizetések ennél a fizetési módnál",
        "header_domain": "Domain",
        "header_plan": "Csomag",
        "header_status": "Állapot",
        "header_actions": "Műveletek",
        "cancelling": "Lemondva: {{0}}",
        "next_payment": "Következő fizetés: {{0}}",
        "action_renew": "Megújítás",
        "no_subs_header": "Nincs megjeleníthető előfizetés",
        "no_subs_desc": "Amint lesz előfizetés ehhez a kártyához, minden információ itt megjelenik",
        "action_manage": "Kezelés"
      },
      "status": {
        "active": "Aktív",
        "canceled": "Lemondva",
        "incomplete": "Kifizetetlen",
        "incomplete_expired": "Kifizetetlen (lejárt)",
        "missing": "Hiba",
        "past_due": "Lejárt",
        "trialing": "Próba",
        "unpaid": "Ki nem fizetett"
      }
    },
    "delete_confirm_body": "Biztosan törölni akarod ezt a fizetési módot? A művelet nem vonható vissza!",
    "delete_confirm_header": "Törli a fizetési módot?",
    "card_edit": {
      "header": "Kártya szerkesztése",
      "billing_header": "Számlázási adatok",
      "address_error": "Cím megadása kötelező!",
      "card_number": "Kártyaszám",
      "card_expiry": "Lejárati dátum",
      "expiry_error_month": "Érvénytelen hónap lett megadva",
      "expiry_error_year": "Érvénytelen év lett megadva",
      "expiry_error_expired": "A kártya lejárati éve már a múltban van.",
      "card_header": "Kártya adatok",
      "expiry_error_empty": "Ez a mező kötelező!"
    }
  },
  "plans": {
    "per": "per",
    "wordsTranslated": "lefordított szó",
    "current": "Aktuális",
    "archived": "Archivált",
    "day": "nap",
    "week": "hét",
    "month": "hónap",
    "year": "év",
    "activate": "Aktiválás",
    "cancel": "Mégsem",
    "change": "Módosítás",
    "upgrade": "Frissítés",
    "downgrade": "Visszalépés",
    "resume": "Folytatás",
    "notEnoughWords": "Nincs elég szó",
    "yearIntervalOnly": "Nem lehet áttérni éves tervről",
    "subsCanceled": "Folyamatban van egy másik lemondás",
    "wordsUnlimited": "Korlátlan szó",
    "tabs": {
      "day": "Napi árak",
      "week": "Heti árak",
      "month": "Havi árak",
      "year": "Éves árak",
      "sub_texts": {
        "day": "Egy rögzített ár, minden nap",
        "week": "Egy rögzített ár, minden héten",
        "month": "Egy rögzített ár, minden hónapban",
        "year": "Egy hónap ingyen, évente egy számla"
      }
    },
    "details": {
      "new_languages": "Új nyelvek bármikor hozzáadhatók",
      "one_month_trial": "Egyhónapos ingyenes próba minden új weboldalhoz",
      "multi_content_indexed": "100%-ban indexelt többnyelvű tartalom",
      "translate_new_content": "Új tartalom azonnali lefordítása",
      "free_installation": "Ingyenes telepítés és beállítás",
      "compared_monthly_plan": "Egy hónap ingyen a havi tervekhez képest",
      "risk_free_recurring": "Kockázatmentes ismétlődő fizetési hiba",
      "unlimited_languages": "Korlátlan nyelv és lapmegtekintés",
      "high_server_resources": "Nagy szerver-erőforrás",
      "billed": {
        "day": "Naponta számlázva",
        "week": "Hetente számlázva",
        "month": "Havonta számlázva",
        "year": "Évente számlázva"
      },
      "request_max_size": "{{0}} kérelem maximális mérete"
    },
    "frequent_question": {
      "title": "Gyakori kérdések",
      "questions": {
        "trial": {
          "question": "Használhatom a próbát új weboldal-domainen?",
          "answer": "Igen, minden új weboldal-domainhez kínálunk 30 napos ingyenes próbát, amellyel teljes körűen tesztelheti a fordítási szolgáltatást."
        },
        "seo": {
          "question": "Mennyi idő alatt javul az SEO-m?",
          "answer": "A tartalom, köztük a többnyelvű tartalom indexelése és jó helyezése időt vesz igénybe: 3–6 hét a forgalomtól és a mérettől függően."
        },
        "quota": {
          "question": "Beleszámítanak a kvótába az emberi fordítások?",
          "answer": "Nem, a szólimit csak a gépi fordításokra vonatkozik. A fordító korlátlanul javíthatja kézzel az automata fordításokat."
        }
      }
    },
    "best_offer": "Legjobb ajánlat",
    "period": {
      "days@@one": "nap",
      "days@@other": "{{count}} nap",
      "hours@@one": "óra",
      "hours@@other": "{{count}} óra",
      "minutes@@one": "perc",
      "minutes@@other": "{{count}} perc",
      "seconds@@one": "másodperc",
      "seconds@@other": "{{count}} másodperc"
    },
    "words": {
      "billion": "{{value}}Mrd",
      "million": "{{value}}M",
      "thousand": "{{value}}E"
    },
    "throttling_info": "{{words}} szó per {{period}}"
  },
  "profile": {
    "welcome": "Üdvözöljük!",
    "account": "Fiókom",
    "subscriptions": "Előfizetések",
    "logout": "Kijelentkezés"
  },
  "register": {
    "errors": {
      "password": "Minimum 8 karakter, bármilyen karakter"
    }
  },
  "route": {
    "dashboard": "Irányítópult",
    "rules": "Szabályok",
    "translations": "Fordítások",
    "search_translations": "Keresési lekérdezések",
    "urls_translations": "URL-fordítások",
    "links": "Média és külső hivatkozások",
    "online_editor": "Élő szerkesztő",
    "settings": "Beállítások",
    "domain": {
      "finish": "Beállítások",
      "preconfig": "Beállítások"
    },
    "home": "Kezdőlap",
    "domain_list": "Domainlista",
    "members": "Tagok",
    "invoices": "Számlák",
    "billing": "Számlázási adatok",
    "language_display": "Nyelvi zászlók megjelenítése",
    "payment_methods": "Fizetési módok",
    "ai_translation": "AI-fordítás",
    "ai_translation_settings": "Beállítások",
    "ai_translation_pricing": "Árak"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Figyelmen kívül hagyható szöveg",
        "add": "Új hozzáadása",
        "title": "Figyelmen kívül hagyandó szöveg",
        "description": "Adj meg egy vagy több figyelmen kívül hagyandó szöveget",
        "ignore_case": "Kis- és nagybetű figyelmen kívül hagyása"
      },
      "html_content": {
        "title": "Alkalmazás HTML-tartalomra",
        "description": "Szabály alkalmazása az egész tartalomra vagy egy adott CSS-szelektor kiválasztásával",
        "all_page": "Teljes oldal",
        "css_selector": "CSS-szelektor",
        "label": "CSS-szelektor",
        "placeholder": "Alkalmazandó szelektor",
        "add": "Új hozzáadása"
      },
      "apply_to_urls": {
        "title": "Alkalmazás az URL-ekre",
        "description": "Válassza ki azokat a konkrét URL-eket, ahol alkalmazni szeretné a szabályt",
        "all_urls": "Minden URL",
        "selected_urls": "Kiválasztott URL-ek",
        "label": "Alkalmazandó URL",
        "placeholder": "Alkalmazandó URL",
        "original_url": "Eredeti URL-ek",
        "translated_url": "Lefordított URL",
        "wildcard": "Helyettesítő karakter",
        "regex": "Reguláris kifejezés",
        "add": "Új hozzáadása",
        "expression": "Kifejezés típusa"
      },
      "apply_urls": {
        "title_exclude": "Kizárás az URL-ekből",
        "title_replace": "Csere az URL-ekben",
        "title_description": "Szabály alkalmazása az URL-ek fordítására is"
      },
      "apply_languages": {
        "title": "Alkalmazás a nyelvekre",
        "description": "Válassza ki azokat a konkrét nyelveket, ahol alkalmazni szeretné a szabályt",
        "all_languages": "Minden nyelv",
        "selected_languages": "Kiválasztott nyelvek",
        "placeholder": "Válasszon nyelveket...",
        "feedback": "Ki kell választania egy nyelvet"
      },
      "name": {
        "title": "Cím",
        "description": "Adjon címet a szabálynak a kényelem érdekében",
        "placeholder": "Szabály neve"
      },
      "type": {
        "title": "Típus",
        "description": "Válassza ki a hozzáadni kívánt szabály típusát",
        "text_ignore": "Szöveg figyelmen kívül hagyása",
        "text_replace": "Szöveg csere",
        "content_exclusion": "Tartalom kizárása",
        "url_exclusion": "Kizárás URL alapján",
        "ignore_inline": "Inline figyelmen kívül hagyása",
        "full_description": {
          "text_ignore": "Adj hozzá szabályokat, hogy bizonyos szövegek ne legyenek lefordítva. Ez lehet a termékneve, márkaneve vagy más technikai elem, amit nem szeretne lefordítani.",
          "text_replace": "A szöveg csere lehetővé teszi bizonyos szövegek általad megadott fordításra való cseréjét, ami akkor lehet szükséges, ha a fordítás figyelmen kívül hagyja a kontextust.",
          "content_exclusion": "A tartalom kizárása segít elkerülni bizonyos oldal tartalmak fordítását.\n Ha teljes egészében ki szeretne zárni egy oldalt a fordításból (ehhez az oldalhoz nem lesz többnyelvű URL és nem lesz lefordított tartalom), kérjük, használja a „Kizárás URL alapján” típust",
          "url_exclusion": "Az oldal-fordítás kizárása segít beállítani azokat az oldalakat, amelyeket nem szeretnél lefordítani.",
          "ignore_inline": "Kerüld el bizonyos tartalmak inline fordítását, fordítsd inkább minden címkét külön-külön."
        }
      },
      "text_replace": {
        "title": "Csere szövege",
        "description": "Cserélj ki bizonyos szövegeket a te saját fordításodra. Cserélj ki bármit az oldalaidon, nyelvenként…",
        "text_to_replace": "Csere szövege",
        "ignore_case": "Kis- és nagybetű figyelmen kívül hagyása",
        "text_type": "Csere a fordításban",
        "text_type_original": "Eredeti",
        "text_type_translation": "Fordítás",
        "keep_case": "Próbálja meg megőrizni a betűtípust",
        "add": "Új hozzáadása"
      },
      "content_exclusion": {
        "title": "Tartalom kizárása",
        "description": "Válasszon egy vagy több CSS-szelektort, amelyek nem lesznek lefordítva",
        "label": "CSS-szelektor",
        "placeholder": "Alkalmazandó szelektor",
        "add": "Új hozzáadása"
      },
      "multilingual_url": {
        "title": "Többnyelvű URL használata",
        "description": "Ha „Igen”-re van állítva, az URL nem lesz lefordítva, de az oldal többnyelvű marad lefordított tartalommal",
        "live_example_title": "Élő példa",
        "live_example_description": "Forrás URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "Létrehozott URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "Létrehozott URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "Alkalmazza a szabályt statikus tartalomra, dinamikus tartalomra vagy mindkettőre",
        "title": "Alkalmazás a tartalomra",
        "all": "Minden tartalom",
        "static": "Statikus tartalom",
        "dynamic": "Dinamikus tartalom"
      },
      "force_apply_urls": {
        "title_description": "Szabály kényszerített alkalmazása minden URL-fordításra, beleértve a meglévő fordításokat is!",
        "title_replace": "Kényszerített csere az URL-ekben",
        "title_exclude": "Kényszerített kizárás az URL-ekben",
        "warning": "Figyelmeztetés",
        "warning_part1": "Ha ezt „Igen”-re állítja, az megsértheti webhelye URL-fordításait.",
        "warning_part2": "Ez ideiglenesen vagy véglegesen 404-es oldalt eredményezhet, kérjük, csak akkor folytassa, ha megérti a következményeket.",
        "warning_replacement_original": "További figyelmeztetés: Az eredeti tartalom cseréjére tett kísérlet hatással lehet az URL-re, a fordítás meghiúsulhat, mivel a Linguise nem tudja megfelelően megtalálni az eredeti URL-eket"
      }
    },
    "main": {
      "parent": "Szabályok",
      "edit": "Szabály szerkesztése",
      "add": "Új szabály"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "„{{text_ignore}}” figyelmen kívül lesz hagyva a tartalomban és az URL-ben",
      "preview_single": "„{{text_ignore}}” figyelmen kívül lesz hagyva a tartalomban",
      "preview_more_with_url": "„{{text_ignore}}” és még {{count}} elem figyelmen kívül lesz hagyva a tartalomban",
      "preview_more": "„{{text_ignore}}” és még {{count}} elem figyelmen kívül lesz hagyva a tartalomban",
      "other_parameters": "Egyéb paraméterek vannak beállítva ehhez a szabályhoz, kattintson a szerkesztés gombra további információért"
    },
    "text_replace": {
      "preview_single_with_url": "„{{original}}” le lesz cserélve „{{replacement}}”-re a tartalomban és az URL-ekben",
      "preview_single": "„{{original}}” le lesz cserélve „{{replacement}}”-re a tartalomban",
      "preview_more_with_url": "„{{original}}” le lesz cserélve „{{replacement}}”-re a tartalomban és az URL-ekben, és még {{nb}}",
      "preview_more": "„{{original}}” le lesz cserélve „{{replacement}}”-re a tartalomban, és még {{nb}}",
      "other_parameters": "Egyéb paraméterek vannak beállítva ehhez a szabályhoz, kattintson a szerkesztés gombra további információért"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS-szelektor van kizárva a fordításból",
      "other_parameters": "Egyéb paraméterek vannak beállítva ehhez a szabályhoz, kattintson a szerkesztés gombra további információért"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL van kizárva a fordításból, de megtartja a többnyelvű előtagot",
      "some": "{{nb}} URL van teljes egészében kizárva a fordításból",
      "all_multilingual": "minden URL ki van zárva a fordításból, de megtartja a többnyelvű előtagot",
      "all": "minden URL teljes egészében ki van zárva a fordításból",
      "other_parameters": "Egyéb paraméterek vannak beállítva ehhez a szabályhoz, kattintson a szerkesztés gombra további információért"
    },
    "ignore_inline": {
      "elements": "Minden inline tartalom blokktartalomként lesz lefordítva az oldalon",
      "all_elements": "Néhány inline tartalom blokktartalomként lesz lefordítva az oldalon",
      "other_parameters": "További paraméterek is be vannak állítva ehhez a szabályhoz, kattintson a Szerkesztés gombra további információkért"
    },
    "title": "Szabályok kezelése",
    "description": "Kezelje a fordítások tartalomkizárásait és cseréit az egész webhelyén",
    "add": "Új szabály hozzáadása",
    "table": {
      "title": "Cím",
      "no_data": "Még nincsenek szabályok",
      "type": "Típus",
      "preview": "Szabály előnézete",
      "action": "Művelet",
      "delete_confirm": "Kérjük, erősítse meg a szabály törlését",
      "types": {
        "text_ignore": "Szöveg mellőzése",
        "text_replace": "Szöveg cseréje",
        "content_exclusion": "Tartalom kizárása",
        "url_exclusion": "URL kizárása",
        "ignore_inline": "Inline mellőzése",
        "unknown": "Ismeretlen szabály"
      }
    },
    "apply_on_content": {
      "static": "Ez a szabály csak statikus tartalomra vonatkozik.",
      "dynamic": "Ez a szabály csak dinamikus tartalomra lesz érvényes."
    }
  },
  "search_translations": {
    "title": "Keresési lekérdezések kezelése",
    "description": "Az összes keresőmezőkben használt weboldalfordítás listázása (fordított nyelvről az alap domain-nyelvre)",
    "filter_languages": "Szűrés nyelv szerint…",
    "filter_original": "Szűrés eredeti nyelvű szövegre",
    "filter_translation": "Szűrés fordított szöveg szerint",
    "table": {
      "original": "Eredeti",
      "language": "Nyelv",
      "translation": "Fordítás"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Az előfizetés sikertelen!",
      "title": "Az előfizetés sikertelen!",
      "subtitle": "Hiba történt az előfizetés feldolgozása közben.",
      "home": "Vissza a főoldalra",
      "generic": "Ismeretlen hiba történt a Linguise oldalán; kérjük, forduljon a rendszergazdához!"
    },
    "success": {
      "home": "Domain-fordítások kezelése",
      "message": "Mi elkötelezettek vagyunk, hogy a legjobb fordítási élményt nyújtsuk Neked. Szakértőink minden kérdésedben és támogatásban készséggel állnak rendelkezésedre – kezdéshez egyszerűen kattints az alábbi gombra.",
      "subtitle": "Köszönjük, hogy a Linguise fordítási szolgáltatását választottad!",
      "title": "Előfizetés aktiválva!",
      "tab_title": "Köszönjük az előfizetést!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "Előfizetés aktiválva!",
      "title": "Előfizetés aktiválva!",
      "subtitle": "Köszönjük, hogy a Linguise fordítási szolgáltatását választottad!",
      "message": "‘Mi elkötelezettek vagyunk, hogy a lehető legjobb fordítási élményt nyújtsuk Neked. Szakértőink minden kérdésedben és támogatásban készséggel állnak rendelkezésedre – kezdéshez egyszerűen kattints az alábbi gombra.",
      "home": "Domain-fordítások kezelése"
    },
    "edit": {
      "title": "Előfizetés kezelése"
    },
    "list": {
      "title": "Előfizetések listája",
      "description": "Domain-előfizetéseid listája"
    },
    "table": {
      "domain": "Domain",
      "plan": "Csomag",
      "status": "Állapot",
      "card": "Kártya",
      "usage": "Felhasználás",
      "actions": "Műveletek",
      "payment_method": "Fizetési mód"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} szó",
      "paidOffered": "{{words_used}} / {{words_allowed}} szó\n({{free_words}} ingyen felajánlott szó)"
    },
    "popup": {
      "dueToday": "Összesen ma esedékes",
      "nextPeriod": "Kezdés: {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Válassz fiókot"
    }
  },
  "translation": {
    "main": {
      "parent": "Fordítások",
      "edit": "Fordítás szerkesztése"
    },
    "form": {
      "original": {
        "title": "Eredeti nyelv: {{language}}"
      },
      "is_inline": "Ez a fordítás inline tartalomból készült.",
      "inline_editor": {
        "count_warning": "A beágyazott területek száma nem egyezik az eredetivel ({{current}} / {{expected}}).",
        "restore_original": "Eredeti szöveg visszaállítása",
        "insert_placeholder": "Helyőrző beszúrása",
        "drag": "Húzza át a terület átrendezéséhez",
        "area": "{{index}}. soron belüli terület",
        "restore": "Hiányzó beágyazott területek visszaállítása"
      },
      "translation": {
        "title": "{{language}} fordítás",
        "description": "A felülírandó fordítás"
      }
    },
    "copy": {
      "title": "Másolás a kézi fordításba",
      "label": "Másolás kézibe"
    },
    "level": {
      "base": {
        "title": "Alapfordítás",
        "subtitle": "Automatikus · Linguise Cloud fordítás",
        "empty": "Ehhez a szöveghez nincs alapfordítás.",
        "overridden": "A választása mentve van, de helyette a legújabb AI-val továbbfejlesztett fordítás jelenik meg, mert az AI-fordítás beállításaiban a „Kézi és kiválasztott fordítások felülírása” értéke Igen. Kapcsolja ki a beállítást, ha a saját választását szeretné használni."
      },
      "not_generated": "Nincs létrehozva",
      "none": "Még nincs",
      "ai": {
        "title": "AI-val továbbfejlesztett fordítás",
        "subtitle": "Automatikus · Linguise AI",
        "empty_title": "Ehhez a szöveghez még nincs létrehozva",
        "empty_description": "A Linguise AI természetesebb fordításokat készít az oldal és a webhely kontextusa alapján. Ha ide szeretne egyet:",
        "empty_step_1": "Nyissa meg az AI-fordítás › Beállítások oldalt, és az AI fordítás engedélyezése beállítást állítsa „Csak szabályok”, „Csak élő szerkesztő” vagy „Szabályok és élő szerkesztő” értékre.",
        "empty_step_2": "Alkalmazza egy erre az oldalra illeszkedő szabállyal, vagy engedélyezze oldalanként az élő szerkesztőből.",
        "empty_step_3": "Az AI-val továbbfejlesztett fordítás a létrehozása után itt jelenik meg. AI-kreditet használ fel.",
        "open_settings": "AI-fordítás beállításainak megnyitása",
        "open_editor": "Élő szerkesztő megnyitása",
        "overrides_selection": "A választása mentve van, de helyette ez az AI-val továbbfejlesztett fordítás jelenik meg, mert az AI-fordítás beállításaiban a „Kézi és kiválasztott fordítások felülírása” értéke Igen. Kapcsolja ki a beállítást, ha a saját választását szeretné használni.",
        "overrides_version": "A kiválasztott verzió mentve van, de helyette a legújabb AI-val továbbfejlesztett verzió jelenik meg, mert az AI-fordítás beállításaiban a „Kézi és kiválasztott fordítások felülírása” értéke Igen. Kapcsolja ki a beállítást, ha a kiválasztott verziót szeretné használni."
      },
      "manual": {
        "title": "Kézi fordítás",
        "subtitle": "Ön írta · elsőbbséget élvez az automatikus fordításokkal szemben",
        "empty": "Üres",
        "saved_but_overridden": "Mentve az Ön választásaként, de automatikusan nem jelenik meg, mert az AI-fordítás beállításaiban a „Kézi fordítások felülírása” értéke Igen: az AI-val továbbfejlesztett fordítás érvényesül, amíg ezt a beállítást ki nem kapcsolja.",
        "ignored": "Automatikusan nem jelenik meg, mert az AI-fordítás beállításaiban a „Kézi fordítások felülírása” értéke Igen. Válassza ki, ha ehhez a szöveghez ezt szeretné használni.",
        "label": "Az Ön fordítása",
        "placeholder": "Írja be saját fordítását...",
        "last_updated": "Utoljára szerkesztve: {{date}}",
        "save_hint": "A kézi fordítás mentésekor az aktívvá válik.",
        "delete": "Kézi fordítás törlése",
        "delete_confirm": "Erősítsd meg a kézi fordítás törlését"
      }
    },
    "history": {
      "title": "AI-val továbbfejlesztett verziók",
      "subtitle": "Az élő szerkesztőből indított minden újragenerálás megmarad",
      "unknown_model": "Ismeretlen modell",
      "current": "Aktuális",
      "restore": "Verzió visszaállítása",
      "restore_note": "A visszaállítással az adott verzió lesz az aktuális AI-val továbbfejlesztett fordítás. Semmi sem törlődik.",
      "version_of": "{{current}}. verzió / {{total}}",
      "hide": "Előzmények elrejtése ({{total}})",
      "show": "Előzmények megjelenítése ({{total}})"
    },
    "choose": {
      "title": "Fordítások ({{language}}) · válassza ki, melyiket lássák a látogatók",
      "current": "Jelenleg a webhelyén:",
      "priority": "Alapértelmezett sorrend: kézi › AI-val továbbfejlesztett › alap. A választás csak erre a fordításra érvényes.",
      "reset": "Visszaállítás az alapértelmezett sorrendre",
      "reset_title": "A szöveghez választott beállítás elvetése és az alapértelmezett sorrend újbóli használata",
      "resetting": "Visszaállítás..."
    }
  },
  "translations": {
    "title": "Fordítások kezelése",
    "description": "Weboldalad összes fordításának listázása és szerkesztése; vizuális fordításhoz használd az Élő Szerkesztőt",
    "filter_languages": "Szűrés nyelv szerint…",
    "filter_original": "Szűrés eredeti nyelvű szövegre",
    "filter_translation": "Szűrés fordított szöveg szerint",
    "table": {
      "original": "Eredeti",
      "language": "Nyelv",
      "action": "Művelet",
      "base": "Alap",
      "ai": "AI-s",
      "manual": "Kézi"
    },
    "filter_exact": "Pontos találat",
    "badge": {
      "active": "Aktív",
      "overrides_manual": "Felülírja a kézit"
    },
    "cell": {
      "none": "nincs",
      "not_generated": "nincs létrehozva",
      "ignored": "Figyelmen kívül hagyva – az AI-szabály győz"
    },
    "tabs": {
      "all": "Összes",
      "manual": "Van kézi",
      "ai": "Van AI-s",
      "base": "Csak alap"
    },
    "levels_hint": "Minden szövegnek legfeljebb 3 szintje van — az Aktív jelölésű az, amit a látogatók látnak."
  },
  "url": {
    "main": {
      "parent": "URL-ek",
      "edit": "URL-fordítás szerkesztése"
    },
    "form": {
      "original": {
        "title": "Eredeti nyelv: {{language}}"
      },
      "translation": {
        "title": "{{language}} URL-fordítás",
        "description": "A felülírandó URL",
        "placeholder": "URL-fordítás felülírása",
        "invalid_full": "Hibás formátumot adtál meg; csak a slugokat/útvonalakat változtathatod meg az URL-fordításnál",
        "invalid": "Érvénytelen URL/útvonal megadva"
      }
    }
  },
  "urls": {
    "title": "URL-ek kezelése",
    "description": "Weboldalad összes lefordított URL-jének listázása és szerkesztése (haladó; vigyázz a 404-es hibákkal)",
    "filter_languages": "Szűrés nyelv szerint…",
    "filter_original": "Szűrés eredeti nyelvű szövegre",
    "filter_translation": "Szűrés fordított szöveg szerint",
    "table": {
      "original": "Eredeti",
      "language": "Nyelv",
      "url": "Lefordított URL",
      "action": "Művelet",
      "edited": "Az eredeti fordítás módosítva lett"
    }
  }
}
